
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit/itez",
      function () {
        return require("private-next-pages/credit/itez/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit/itez"])
      });
    }
  